import { IconColour, ISvgColours } from 'Shared/backend/IconColour';

export function Hourglass(P:ISvgColours)
{	
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={`fill:${P.fill ?? IconColour.green}; stroke:${P.stroke ?? IconColour.green};`}>
			<path d="M128 96C128 78.3 142.3 64 160 64L480 64C497.7 64 512 78.3 512 96C512 113.7 497.7 128 480 128L480 139C480 181.4 463.1 222.1 433.1 252.1L365.2 320L433.1 387.9C463.1 417.9 480 458.6 480 501L480 512C497.7 512 512 526.3 512 544C512 561.7 497.7 576 480 576L160 576C142.3 576 128 561.7 128 544C128 526.3 142.3 512 160 512L160 501C160 458.6 176.9 417.9 206.9 387.9L274.8 320L206.9 252.1C176.9 222.1 160 181.4 160 139L160 128C142.3 128 128 113.7 128 96zM224 128L224 139C224 164.5 234.1 188.9 252.1 206.9L320 274.8L387.9 206.9C405.9 188.9 416 164.5 416 139L416 128L224 128zM224 512L416 512L416 501C416 475.5 405.9 451.1 387.9 433.1L320 365.2L252.1 433.1C234.1 451.1 224 475.5 224 501L224 512z"/>
		</svg>

	);
		/*
		<svg style={`fill:${P.fill ?? IconColour.green}; stroke:${P.stroke ?? IconColour.green};`} 
			viewBox='0 0 64 64' enable-background='new 0 0 64 64' >
		  <path d='M32,2C15.431,2,2,15.432,2,32c0,16.568,13.432,30,30,30c16.568,0,30-13.432,30-30C62,15.432,48.568,2,32,2z M25.025,50
			l-0.02-0.02L24.988,50L11,35.6l7.029-7.164l6.977,7.184l21-21.619L53,21.199L25.025,50z' ></path>
		</svg>
	*/
}
